module.exports = __webpack_public_path__ + "media/images/person_avatar_96x96-2a69963d1b49a0066936cd57344794d1.png";